(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("digitaljs", [], factory);
	else if(typeof exports === 'object')
		exports["digitaljs"] = factory();
	else
		root["digitaljs"] = factory();
})(this, () => {
return 